// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","pagination_active":"Pagination_pagination_active__6jfm6","pagination_number":"Pagination_pagination_number__c0Eel"};